import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import { CommonDtoKeysEnum } from '@zaoblako/shared/common/enums/common-dto-keys.enum';
import { ReportItemColumnTypeEnum } from '@zaoblako/shared/common/enums/report-item-column-type.enum';
import { DateFormatEnum } from '@zaoblako/shared/common/enums/date.format.enum';
import type { ReportRowColumnDescriptorInterface } from '@zaoblako/shared/common/dtos/report/report-row-column-descriptor.dto';

import * as yup from 'yup';

/** Auto-disableable object common request and response body - DTO signature */
export interface AutoDisableableInterface {
  /** Is object disabled */
  disabled?: boolean;
  /** If date defined, then object will be automatically disabled at this date */
  activeUntil?: Date;
}

/** Auto-disableable object common request and response body - DTO schema */
export const AutoDisableableDto = SerdeDtoClass.create<AutoDisableableInterface>(CommonDtoKeysEnum.AUTO_DISABLEABLE_DTO, {
  disabled: {
    sortable: true,
    optional: true,
    label: 'Объект неактивен',
    serializer: yup.boolean(),
  },
  activeUntil: {
    sortable: true,
    optional: true,
    label: 'Объект активен до',
    serializer: yup.date(),
  },
});

/**
 * Get standard report columns for {@link AutoDisableableInterface}
 *
 * @returns Column descriptors list
 */
export function getAutoDisableableDtoColumns(): ReportRowColumnDescriptorInterface[] {
  return [
    {
      sortable: true,
      key: 'activeUntil',
      title: 'Действует до',
      type: ReportItemColumnTypeEnum.DATE,
      dateFormat: DateFormatEnum.DATE_FORMAT,
    },
    {
      sortable: true,
      key: 'disabled',
      title: 'Статус',
      type: ReportItemColumnTypeEnum.BOOLEAN,
    },
  ];
}
